export const theme = {
  textColor: "#333",
  textColorMuted: "#888",
  buttonColor: "yellow",
  buttonHover: "orange",
  indent: "20px",
  font: 'Arial, "Helvetica", sans-serif',
  button: {
    large: {
      height: "40px",
      padding: "40px",
      fontSize: "24px",
      radius: "10px"
    },
    medium: {
      height: "30px",
      padding: "30px",
      fontSize: "18px",
      radius: "5px"
    },
    small: {
      height: "20px",
      padding: "8px",
      fontSize: "16px",
      radius: "3px"
    }
  }
};
